import { connect } from "react-redux";
import B2CEdit from "./CaseEdit";
import { bindActionCreators } from "redux";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';
import {
    carBrandRequest,
    carModelRequest,
    carVariantRequest,
    bankListRequest,
    loanApplicationByIdRequest,
    loanApplicationUpdateRequest,
    loanAccountRequest,
    addCaseRequest,
    newBankDetailsRequest,
    vehicleDetailsRequest, 
    updateLoanApplicationForB2C,
    carBrandForB2CRequest,
    carModelForB2CRequest
} from "../../../../../services/redux/CarLoan/action";
import { locationPinCode, locationCity } from "services/redux/sales/corporate/locations/action";
const mapStateToProps = (state) => ({
    carBrandResponse : state.CarLoan.carBrandResponse,
    carModelResponse : state.CarLoan.carModelResponse,
    carVariantResponse : state.CarLoan.carVariantResponse,
    bankListResponse : state.CarLoan.bankListResponse,
    ucdCaseByIdResponse : state.CarLoan.loanApplicationByIdResponse,
    loanApplicationUpdateResponse : state.CarLoan.loanApplicationUpdateResponse,
    loanAccountResponse : state.CarLoan.loanAccountResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    addCaseResponse : state.CarLoan.addCaseResponse,
    newBankDetailsResponse : state.CarLoan.newBankDetailsResponse,
    vehicleDetailsResponse : state.CarLoan.vehicleDetailsResponse,
    updateb2cloanapplication: state.CarLoan.updateb2cloanapplication,
    pincodeData: state.locationReducer.pincodeData,
    cities: state.locationReducer.cities,
    carBrandForB2cResponse: state.CarLoan.carBrandForB2cResponse,
    carModelForB2cResponse: state.CarLoan.carModelForB2cResponse
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        documentUploadUrlPublic,
        carBrandRequest,
        carModelRequest,
        carVariantRequest,
        bankListRequest,
        loanApplicationByIdRequest,
        loanApplicationUpdateRequest,
        loanAccountRequest,
        addCaseRequest,
        newBankDetailsRequest,
        vehicleDetailsRequest, 
        updateLoanApplicationForB2C,
        locationPinCode,
        locationCity,
        carBrandForB2CRequest,
        carModelForB2CRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(B2CEdit);